import React, { useEffect, useState } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import Call from '@material-ui/icons/Call';
import Account from '@material-ui/icons/AccountCircleOutlined';
import GridContainer from 'components/Grid/GridContainer';
import GridItem from 'components/Grid/GridItem';
import UserDetails from 'views/Users/Details/UserDetails';
import Numbers from 'views/Users/Details/Numbers';
import CustomNavigationButtons from 'components/CustomNavigationButtons/CustomNavigationButtons';
import { UsersService } from 'services/users/users';
import { useDispatch } from 'react-redux';
import { hideLoadingIndicator, showLoadingIndicator } from 'redux/modules/api/loadingIndicator/actions';
import { finalize } from 'rxjs/operators';
import { throwError } from 'rxjs';
import moment from 'moment';
import { SinglePermission } from 'utils/api/models/users/singlePermission';

interface IUsersProps {
	match: {
		path: string;
		params: {
			userId: string;
			subpage: string;
		};
		url: string;
	};
}

const tabs = [
	{
		value: 'user-details',
		icon: Account,
		id: 'user-details-tab',
	},
	{
		value: 'numbers',
		icon: Call,
		id: 'user-numbers-tab',
	},
];

const Details = ({ match }: IUsersProps) => {
	const [user, setUser] = useState<types.users.IExtendedCorpUserDetails | null>(null);
	const [loading, setLoading] = useState(true);
	const { userId, subpage } = match.params;
	const path = `/dashboard/users/${userId}`;
	const dispatch = useDispatch();

	useEffect(() => {
		dispatch(showLoadingIndicator());
		UsersService.getCorpUserDetails(userId)
			.pipe(
				finalize(() => {
					dispatch(hideLoadingIndicator());
					setLoading(false);
				})
			)
			.subscribe(
				(user) =>
					setUser({
						...user,
						permissions: (user.permissions || []).map((permission: SinglePermission) => ({
							...permission,
							permissionExpiration: permission.permissionExpiration
								? moment(permission.permissionExpiration).format('YYYY-MM-DD')
								: undefined,
						})),
					}),
				(error) => throwError(error)
			);
	}, [userId, dispatch]);

	return (
		<>
			{!loading && (
				<GridContainer>
					<GridItem xs={12}>
						<CustomNavigationButtons path={path} tabs={tabs} value={subpage || 'user-details'} />
					</GridItem>
					<GridItem xs={12}>
						<Switch>
							<Route
								path={`${match.path}/user-details`}
								exact
								render={(props: any) => (
									<UserDetails
										user={user}
										setUser={(value: types.users.IExtendedCorpUserDetails) => setUser(value)}
										{...props}
									/>
								)}
							/>
							<Route
								path={`${match.path}/numbers`}
								render={(props: any) => <Numbers user={user} {...props} />}
							/>
							<Redirect to={`${path}/user-details`} />
						</Switch>
					</GridItem>
				</GridContainer>
			)}
		</>
	);
};

export default Details;
